import { AnyError } from '@futrli/errors';
import { FormattedMessage } from '@futrli/localisation';
import classNames from 'classnames';
import React from 'react';
import Typography from 'carbon-react/lib/components/typography';

import styles from '../core/common.scss';
import { AuthError } from '../core/types';

export const getErrorMessage = (
  cognitoSignInError: AuthError,
  federatedSignInError?: AnyError,
  isSageCarbon?: boolean
) => {
  if (cognitoSignInError) {
    return isSageCarbon ? (
      <Typography fontSize="14px" color="errorRed">
        <FormattedMessage
          id="login.wrong_email_password_combination"
          defaultMessage="Oops, we do not recognize this email/password combination - please try again."
        />
      </Typography>
    ) : (
      <p className={classNames('uiTypeLabelRed', styles.formError)}>
        <FormattedMessage
          id="login.wrong_email_password_combination"
          defaultMessage="Oops, we do not recognize this email/password combination - please try again."
        />
      </p>
    );
  }

  if (federatedSignInError) {
    return isSageCarbon ? (
      <Typography fontSize="14px" color="errorRed">
        <FormattedMessage
          id="login.there_was_a_problem_logging_you_in"
          defaultMessage="Oops, there was a problem logging you in - please try again."
        />
      </Typography>
    ) : (
      <p className={classNames('uiTypeLabelRed', styles.formError)}>
        <FormattedMessage
          id="login.there_was_a_problem_logging_you_in"
          defaultMessage="Oops, there was a problem logging you in - please try again."
        />
      </p>
    );
  }

  return null;
};
